module.exports = __webpack_public_path__ + "static/img/banner.9808dfae.png";